import type { Amount } from '@mollie/api-client/dist/types/src/data/global';
import { ERROR_CODES, VoucherActions } from 'types/vouchersV02';

const errorDescriptions: Record<ERROR_CODES, string> = {
  [ERROR_CODES.VOUCHER_NOT_PAID]:
    'Der Gutschein ist nicht bezahlt oder wurde vollständig erstattet.',
  [ERROR_CODES.VOUCHER_EXPIRED]: 'Der Gutschein ist abgelaufen.',
  [ERROR_CODES.VOUCHER_NOT_VALID]: 'Der Gutschein ist nicht gültig.',
  [ERROR_CODES.VOUCHER_NOT_ENOUGH_REMAINING_VALUE]:
    'Der Gutschein hat nicht genügend Restwert.',
  [ERROR_CODES.VOUCHER_ALREADY_REDEEMED]:
    'Der Gutschein wurde bereits vollständig eingelöst.',
  [ERROR_CODES.VOUCHER_CURRENCY_MISMATCH]:
    'Die Währung des Gutscheins stimmt nicht mit dem eingegebenen Betrag überein.',
  [ERROR_CODES.VOUCHER_NOT_FOUND]: 'Der Gutschein wurde nicht gefunden.',
  [ERROR_CODES.PAYMENT_NOT_FOUND]: 'Die Zahlung wurde nicht gefunden.',
  [ERROR_CODES.PAYMENT_ALREADY_REFUNDED]:
    'Die Zahlung wurde bereits vollständig erstattet.',
  [ERROR_CODES.PAYMENT_IS_NOT_PAID]: 'Die Zahlung ist nicht bezahlt.',
  [ERROR_CODES.PAYMENT_NOT_ENOUGH_REMAINING_VALUE]:
    'Die Zahlung hat keinen ausreichenden erstattbaren Restbetrag.',
  [ERROR_CODES.ID_IS_INVALID]: 'Die Gutschein-ID ist ungültig.',
  [ERROR_CODES.AMOUNT_IS_INVALID]: 'Der Betrag ist ungültig.',
};

// Thrown by the action route as plain strings, not part of ERROR_CODES.
const otherDescriptions: Record<string, string> = {
  VOUCHER_ALREADY_CANCELED: 'Der Gutschein ist bereits als ungültig markiert.',
  VOUCHER_NOT_CANCELED: 'Der Gutschein ist nicht als ungültig markiert.',
  UPDATED_BY_IS_MISSING: 'Bitte geben Sie einen gültigen Namen ein',
};

const formatAmount = (amount: Amount) => {
  const value = parseFloat(amount.value);

  if (!Number.isFinite(value)) return null;

  const currency =
    !amount.currency || amount.currency === 'EUR' ? '€' : amount.currency;

  return `${value.toFixed(2).replace('.', ',')} ${currency}`;
};

// An edited redeem also frees its own old amount, so the remaining value alone
// does not explain why the API rejected it.
export const namesRemainingAmount = (
  message: unknown,
  action: VoucherActions,
) =>
  message === ERROR_CODES.VOUCHER_NOT_ENOUGH_REMAINING_VALUE &&
  action !== VoucherActions.editRedeem;

export const getVoucherActionErrorDescription = (
  message: unknown,
  action: VoucherActions,
  remainingAmount?: Amount,
) => {
  if (typeof message !== 'string') {
    return 'Die Gutschein-Aktion konnte nicht ausgeführt werden.';
  }

  if (namesRemainingAmount(message, action) && remainingAmount) {
    const formattedAmount = formatAmount(remainingAmount);

    if (formattedAmount) {
      return `Der Gutschein hat nur noch ${formattedAmount} Restwert.`;
    }
  }

  return (
    errorDescriptions[message as ERROR_CODES] ??
    otherDescriptions[message] ??
    message
  );
};
